import { useMutation } from "@tanstack/react-query";
import type { CalculatorLead } from "web_myplann/Calculators/Types/CalculatorLead";
import { CALCULATOR_TYPE_ENUMS } from "web_myplann/Calculators/Utils/calculatorCatalog";
import { postCalculatorTypeLeadV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

type Options = {
	onSuccess?: () => void;
};

export const useSendCalculatorLeadMutation = ({ onSuccess }: Options = {}) =>
	useMutation<void, Error, CalculatorLead>({
		mutationFn: processResponse(
			({ type, payload }: CalculatorLead) =>
				postCalculatorTypeLeadV2(payload, CALCULATOR_TYPE_ENUMS[type]),
			{ skipToastFor: true },
		),
		onSuccess: () => onSuccess?.(),
	});
